import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CardComponent } from '@app/ui-components/card/card.component';
import { TitleNameFormComponent } from '../title-name-form/title-name-form.component';
import { TitleNameFormGroup } from '../title-name-form/title-name-form.helper';

@Component({
  selector: 'app-title-name-card',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TitleNameFormComponent,
    CardComponent,
  ],
  templateUrl: './title-name-card.component.html',
  styleUrl: './title-name-card.component.scss',
})
export class TitleNameCardComponent {
  formGroup = input.required<FormGroup<TitleNameFormGroup>>();
  title = input.required<string>();
}
